/*
* This has it's own file which can be expanded to add
* plugins and other functionality
*/
const storage = require('store')
export default storage
